import { render, staticRenderFns } from "./DlgPressNew.vue?vue&type=template&id=cae32c88&scoped=true&"
import script from "./DlgPressNew.vue?vue&type=script&lang=ts&"
export * from "./DlgPressNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae32c88",
  null
  
)

export default component.exports